import React from 'react'
import { Link } from "react-router-dom";

const RailTransportation = () => {
    return (
        <>

            <div style={{ overflow: "hidden" }}>
                <section className="section-breadcrumb main-wrapper">
                    <div className="breadcrumb-area">
                        <div className="container">
                            <div className="breadcrumb-wrapper">
                                <nav className="breadcrumb">
                                    <Link className="breadcrumb-item" to="/">Home</Link>
                                    <span className="breadcrumb-item active" aria-current="page">Services</span>
                                </nav>
                                <h1 className="breadcrumb-title">View All Services</h1>
                            </div>
                            <div className="breadcrumb-bg-block">
                                <img src="assets/images/breadcrumb-bg.jpg" alt="breadcrumb-bg" width={1920} height={448} className="img-cover" />
                                <img src="assets/images/breadcrumb-shape.png" alt="breadcrumb-shape" width={1033} height={448} />
                            </div>
                        </div>
                    </div>
                </section>
                <div className="section-service-details">
                    <div className="section-space">
                        <div className="container">
                            <div className="row g-lg-5">
                                <div className="col-md-6 col-lg-7 col-xl-8">
                                    <div className="mb-4">
                                        <img src="assets/images/project-inner-img-1.jpg" alt="service-details-hero-img" width={905} height={546} className="img-fluid rounded" />
                                    </div>
                                    <article className="text-rich">
                                        <h2>Rail Transportation</h2>
                                        <p> With our Rail Cargo Services in Katni, Rahul Logistics, a Katni-based company, offers quick, dependable, and economical logistics solutions. Our Rail Express service, which was created to satisfy the transportation requirements of companies throughout India, provides a safe and cost-effective substitute for air or road freight. Because it combines the advantages of large-capacity transportation with reliable delivery dates and affordable prices, rail freight is a great choice for companies wishing to move bulk items over vast distances.</p>
                                        <p> For businesses in a variety of sectors, including manufacturing and retail, that are searching for a dependable and eco-friendly method of transporting goods across the nation, Rail Express is perfect. Rahul Logistics, Rail Cargo Services in Katni guarantees that your cargo are delivered effectively and safely over India's vast rail network thanks to our proficiency in logistics management and a solid network of partners.</p>
                                        <p> </p>
                                        
                                       
                                        <ul className="content-list content-list-1 flex-wrap d-flex row-gap-2 column-gap-5 flex-wrap">
                                            <li>On-Time Delivery</li>
                                            <li>Real-Time Tracking</li>
                                            <li>Competitive Pricing</li>
                                            <li>Nationwide Coverage </li>
                                            <li>Advanced Technology</li>
                                            <li>24/7 Customer Support</li>
                                            <li>Customer-Centric Approach</li>
                                        </ul>
                                    </article>
                                </div>
                                <div className="col-md-6 col-lg-5 col-xl-4">
                                    <aside>
                                        <ul className="sidebar-list">
                                            <li className="sidebar-banner">
                                                <img src="assets/images/sidebar-banner-img.jpg" alt="sidebar-banner-img" width={368} height={546} className="img-cover" />
                                                <div className="inner-content">
                                                    {/* <span className="fs-5">Start Your Projects</span> */}
                                                    <div className="service-banner-info-block">
                                                        <ul className="get-touch-info-list">
                                                            <li>
                                                                <div className="icon">
                                                                    <i className="fa-light fa-phone" />
                                                                </div>
                                                                <div className="content">
                                                                    <span>24/7 Our Support</span>
                                                                    <a href="tel:+91 8770252599" className="text-white">+91 8770252599</a>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                            {/* Sidebar Item - Banner*/}
                                        </ul>
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default RailTransportation